import { Directive } from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';

@Directive()
/* eslint-disable-next-line @angular-eslint/directive-class-suffix */
export abstract class UIKitBaseComponent extends BaseComponent {}
